export const hasEmptyHtml = (html) =>
  !html || html.replace(/\s/g, '') === '<div></div>';
